import { useContext } from 'react';
import { GlobalContext } from '../../../store/Store';
import ProgressSpinner, {
  IProgressItem,
} from '../../mike-topbar-progress-spinner';
import ActionType from '../../../store/ActionType';
import Api from '../../../apis/meshApi';

function AppSpinners() {
  const [globalState, globalDispatch] = useContext(GlobalContext);

  async function cancelExtractBoundaryConditions(id: string) {
    if (globalState && globalState.project && globalState.project.currentProject) {
      const data: IProgressItem = {
        title: `Canceling extraction`,
        id: id,
        progressValue: 0,
        browserStep: 0,
      };

      globalDispatch({
        type: ActionType.ADDUP_POLLING_ITEM,
        data,
      });

      try {
        await Api.cancelExtraction(id);
        globalDispatch({
          type: ActionType.RM_POLLING_ITEM,
          data,
        });
      } catch (e) {
        console.log('error: ', e.message);
        globalDispatch({
          type: ActionType.SET_MESSAGE,
          message: `Failed to cancel the extraction service: ${e.message}`,
        });
        globalDispatch({ type: ActionType.SET_MESSAGE_TYPE, messagetype: 'error' });
        globalDispatch({ type: ActionType.SET_SHOW_MESSAGE, show: true });
      }
    }
  }
  return (
    <ProgressSpinner
      progressItems={globalState.pollingItems}
      onClickItemButton={(id: string) => cancelExtractBoundaryConditions(id)}
    />
  );
}

export default AppSpinners;
